var map = {
	"./additionalInfoIcon.svg": 591,
	"./arrowLeftIcon.svg": 592,
	"./arrowMediumTop.svg": 593,
	"./arrowRightIcon.svg": 594,
	"./arrowRightIconSharp.svg": 595,
	"./arrowRightSmallIcon.svg": 596,
	"./arrowScalableIcon.svg": 597,
	"./arrowSelect2.svg": 598,
	"./arrowSelectIcon.svg": 599,
	"./benefit1.svg": 600,
	"./benefit2.svg": 601,
	"./benefit3.svg": 602,
	"./cardsIcon.svg": 603,
	"./copyIcon copy.svg": 604,
	"./copyIcon.svg": 605,
	"./crossIcon.svg": 606,
	"./crossIcon2.svg": 607,
	"./crossIcon3.svg": 608,
	"./crossIconSmall.svg": 609,
	"./crossSmallIcon.svg": 610,
	"./defaultCategoryIcon.svg": 611,
	"./depNumberIcon.svg": 612,
	"./elfCentralIcon.svg": 613,
	"./equalitySign.svg": 614,
	"./errorIcon.svg": 615,
	"./eyeClosedIcon.svg": 616,
	"./eyeOpenIcon.svg": 617,
	"./favoritesIcon.svg": 618,
	"./favoritesLabelIcon.svg": 619,
	"./filterDivider.svg": 620,
	"./filterIcon.svg": 621,
	"./frequencyIcon.svg": 622,
	"./fsAmountIcon.svg": 623,
	"./fullScreenIcon.svg": 624,
	"./gameIcon.svg": 625,
	"./hamburgerIcon.svg": 626,
	"./infoIcon.svg": 627,
	"./infoSymbol.svg": 628,
	"./levelBackground.svg": 629,
	"./levelBackgroundNew.svg": 630,
	"./linkIcon.svg": 631,
	"./lockIcon.svg": 632,
	"./lockSharpIcon.svg": 633,
	"./maxBonusAmountIcon.svg": 634,
	"./maxWinFsIcon.svg": 635,
	"./menu/fortuneIcon.svg": 361,
	"./menu/fortuneIconL.svg": 362,
	"./menu/helpdeskIcon.svg": 363,
	"./menu/helpdeskIconL.svg": 364,
	"./menu/homeIcon.svg": 365,
	"./menu/homeIconLarge.svg": 366,
	"./menu/jackpotIcon.svg": 367,
	"./menu/logo.svg": 368,
	"./menu/logoSmall.svg": 369,
	"./menu/loyaltyIcon.svg": 370,
	"./menu/mobileAppIcon.svg": 371,
	"./menu/profileIcon.svg": 372,
	"./menu/questIcon.svg": 373,
	"./menu/rewardLineupIcon.svg": 374,
	"./menu/searchIcon.svg": 375,
	"./menu/searchIconLarge.svg": 376,
	"./menu/signOutIcon.svg": 377,
	"./menu/star.svg": 378,
	"./menu/tournamentIcon.svg": 379,
	"./menu/tournamentLargeIcon.svg": 380,
	"./menu/vipIcon.svg": 381,
	"./menu/wheelIcon.svg": 382,
	"./menu/wheelIconL.svg": 383,
	"./menu/wheelIconMobile.svg": 384,
	"./menuIcon.svg": 636,
	"./minDepIcon.svg": 637,
	"./noTournamentIcon.svg": 638,
	"./numbers/number-1.svg": 385,
	"./numbers/number-2.svg": 386,
	"./numbers/number-3.svg": 387,
	"./numbers/number-4.svg": 388,
	"./numbers/number-5.svg": 389,
	"./numbers/number-6.svg": 390,
	"./numbers/number-7.svg": 391,
	"./numbers/number-8.svg": 392,
	"./numbers/number-9.svg": 393,
	"./numbers/number-shine-1.svg": 394,
	"./numbers/number-shine-2.svg": 395,
	"./numbers/number-shine-3.svg": 396,
	"./numbers/number-shine-4.svg": 397,
	"./numbers/number-shine-5.svg": 398,
	"./numbers/number-shine-6.svg": 399,
	"./numbers/number-shine-7.svg": 400,
	"./numbers/number-shine-8.svg": 401,
	"./numbers/number-shine-9.svg": 402,
	"./playIcon.svg": 639,
	"./polygon.svg": 640,
	"./preloaderDotsAnimation.svg": 641,
	"./preloaderSpinnerAnimation.svg": 642,
	"./presentIcon.svg": 643,
	"./promoIcon.svg": 644,
	"./recentIcon.svg": 645,
	"./search2Icon.svg": 646,
	"./search3Icon.svg": 647,
	"./sharpTickIcon copy.svg": 648,
	"./sharpTickIcon.svg": 649,
	"./smallInfoSymbol.svg": 650,
	"./smoothArrowIcon.svg": 651,
	"./successIcon.svg": 652,
	"./supportIcon.svg": 653,
	"./tag1Icon.svg": 654,
	"./tag2Icon.svg": 655,
	"./tag3Icon.svg": 656,
	"./tag4Icon.svg": 657,
	"./tickIcon.svg": 658,
	"./unverified.svg": 659,
	"./verified.svg": 660,
	"./wagerIcon.svg": 661,
	"./wagerTimeIcon.svg": 662,
	"./warningIcon.svg": 663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 590;